import type { Placement } from '@popperjs/core';
import React from 'react';
import SVGIcon from './SVGIcon';
import Tooltip from './Tooltip';
import styles from './SelectOptionContent.module.scss';

interface SelectOptionContentProps {
  label: string;
  icon: string;
  helpText: string;
  tooltip?: string | null;
  tooltipPlacement?: Placement;
}

const SelectOptionContent = ({
  label,
  icon,
  helpText,
  tooltip = null,
  tooltipPlacement = 'top',
}: SelectOptionContentProps) => {
  const inner = (
    <div className={styles.option}>
      <div className={styles.icon}>
        <SVGIcon inline>{icon}</SVGIcon>
      </div>
      <div>
        <strong>{label}</strong>
        <br />
        {helpText}
      </div>
    </div>
  );

  return tooltip ? (
    <Tooltip
      trigger="hover"
      placement={tooltipPlacement}
      tooltip={tooltip}
      display="block"
      popOverPortal={document.body}
    >
      {inner}
    </Tooltip>
  ) : (
    inner
  );
};

export default SelectOptionContent;
